<template>
    <div class="wrapper wrapper1">
        <h3>人数达标即可获得对应档位奖励</h3>
        <Progress :counts="counts" />
        <div class="counts">
            已有<strong>{{ counts }}</strong
            >人预约游戏
        </div>
        <ul class="btns-wrapper">
            <li>
                <a
                    target="_blank"
                    href="https://xyx.web.sdo.com/web6/download.html"
                    >下载游戏</a
                >
            </li>
            <li class="done" v-if="user.yuyue">已预约</li>
            <li v-else @click="signUp">立即预约</li>
        </ul>
        <p>*道具奖励开服后在天风大陆新区福利使者处领取</p>
    </div>
    <Teleport to=".container">
        <SuccessPop ref="successRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, inject, onMounted } from "vue";
import useStore from "@/store/store";
import { SignUp, GetAmount } from "@/api";
import Progress from "./components/progress.vue";
import SuccessPop from "./components/pop-success.vue";
const loginRef = inject("loginRef");
const successRef = ref(null);
const { user } = storeToRefs(useStore());
const counts = ref(0);

onMounted(async () => {
    getAmount();
});
// 获取预约量
const getAmount = async () => {
    const res = await GetAmount();
    if (res) {
        counts.value = res.amount;
    }
};
// 预约
const signUp = async () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    const res = await SignUp();
    if (res) {
        successRef.value.Show(res.role_count);
        counts.value++;
        user.value.yuyue = 1;
    }
};
</script>

<style lang="scss" scoped>
.wrapper1 {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/2.jpg");
    height: 1309px;
    padding-top: 270px;
    h3 {
        color: #c2a481;
        text-align: center;
    }
    .counts {
        display: flex;
        color: #c2a481;
        justify-content: center;
        align-items: flex-end;
        margin-bottom: 240px;
        strong {
            font-size: 50px;
            padding-top: 4px;
            color: #c2a481;
            position: relative;
            top: 12px;
            margin: 0px 6px;
        }
    }
    .btns-wrapper {
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
        li {
            width: 352px;
            height: 109px;
            line-height: 120px;
            cursor: pointer;
            margin: 0px 30px;
            text-align: center;
            font-size: 32px;
            color: #792520;
            user-select: none;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/btn-bg.png");
            &:not(.done):hover {
                background-position: 0px -131px;
            }
            &.done {
                cursor: default;
            }
            a {
                display: block;
                width: 100%;
                height: 100%;
                color: #792520;
            }
        }
    }
    p {
        text-align: center;
        color: #c2a481;
    }
}
</style>
